module.exports = __webpack_public_path__ + "static/snowboard_park-66b11fd605b54212bc94662eef5f32bc.mp4";